import React from 'react';

import { ToggleLayer, Arrow } from 'react-laag';

import ItemLink from '../../../Layouts/Admin/Dashboard/Navigation/ItemLink';
import Dropdown from '../../Dropdown';
import Icon from '../../Icon';
import ThreeDots from '../../Icon/icons/ThreeDots';
import s from './index.module.css';

function RowOptions({ options }) {
  if (options.length === 0) return null;

  return (
    <ToggleLayer
      renderLayer={({ isOpen, layerProps, arrowStyle, layerSide, close }) =>
        isOpen && (
          <div
            ref={layerProps.ref}
            className="layer"
            style={{
              ...layerProps.style,
              zIndex: 5,
            }}
          >
            <Dropdown type="tooltip">
              {options.map((opt, i) => (
                <ItemLink key={i} isButton isDropdown onClick={() => opt.onClick({ close })}>
                  {opt.name}
                </ItemLink>
              ))}
            </Dropdown>

            <Arrow
              style={{ ...arrowStyle, zIndex: '9' }}
              // style={{ ...arrowStyle, zIndex: '9', top: '-12px' }} top style looks bad in itinerary tables in the mobile version
              layerSide={layerSide}
              borderWidth={1}
              borderColor="rgba(0, 0, 0, 0.04)"
              backgroundColor="#fff"
              angle={40}
              roundness={0.5}
              size={12}
            />
          </div>
        )
      }
      placement={{
        anchor: 'RIGHT_BOTTOM',
        autoAdjust: true,
        triggerOffset: 10,
      }}
      closeOnOutsideClick
    >
      {({ triggerRef, toggle }) => {
        return (
          <div className={s.icon} ref={triggerRef} onClick={toggle}>
            <Icon component={ThreeDots} width="8" height="14" />
          </div>
        );
      }}
    </ToggleLayer>
  );
}

export default RowOptions;
